export default __webpack_public_path__ + "static/media/wire.44371474.svg";